import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Wiki() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('drones');
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    { q: t('wiki.faq.q1'), a: t('wiki.faq.a1') },
    { q: t('wiki.faq.q2'), a: t('wiki.faq.a2') },
    { q: t('wiki.faq.q3'), a: t('wiki.faq.a3') },
    { q: t('wiki.faq.q4'), a: t('wiki.faq.a4') },
    { q: t('wiki.faq.q5'), a: t('wiki.faq.a5') },
    { q: t('wiki.faq.q6'), a: t('wiki.faq.a6') },
  ];

  const useCases = [
    { icon:'🛢️', title: t('wiki.usecases.offshore.title'),   desc: t('wiki.usecases.offshore.desc'),   link:'https://www.youtube.com/watch?v=wRUyqiic4Vw', tag:'VIDEO' },
    { icon:'🔌', title: t('wiki.usecases.cableChile.title'), desc: t('wiki.usecases.cableChile.desc'), link:'https://www.youtube.com/watch?v=SCFPYHueT5k', tag:'VIDEO' },
    { icon:'🔌', title: t('wiki.usecases.cablePt.title'),    desc: t('wiki.usecases.cablePt.desc'),    link:'https://www.youtube.com/watch?v=h8J1LmEjhSs', tag:'VIDEO' },
    { icon:'📡', title: t('wiki.usecases.telecom.title'),    desc: t('wiki.usecases.telecom.desc'),    link:'https://www.youtube.com/watch?v=C8YDb4ADbPg', tag:'VIDEO' },
    { icon:'💨', title: t('wiki.usecases.wind.title'),       desc: t('wiki.usecases.wind.desc'),       link:'https://www.youtube.com/watch?v=DfzrkaHiNAc', tag:'VIDEO' },
    { icon:'🌲', title: t('wiki.usecases.forestry.title'),   desc: t('wiki.usecases.forestry.desc'),   link:'https://www.youtube.com/watch?v=GENKXEYk6O0', tag:'VIDEO' },
    { icon:'📦', title: t('wiki.usecases.middleMile.title'), desc: t('wiki.usecases.middleMile.desc'), link:'https://www.youtube.com/watch?v=tEMysxxR3vE', tag:'VIDEO' },
    { icon:'🏗️', title: t('wiki.usecases.sofia.title'),     desc: t('wiki.usecases.sofia.desc'),     link:'https://www.linkedin.com/posts/sofia-innovation-lab_sofia-almacis-flyingbasket-ugcPost-7387545297788411904-aVNB', tag:'LINKEDIN' },
    { icon:'♻️', title: t('wiki.usecases.sustainable.title'),desc: t('wiki.usecases.sustainable.desc'),link:'https://www.linkedin.com/posts/flyingbasket_sustainabletransportation-cargodrone-dronelogistics-activity-7399416724980273153-UnfT', tag:'LINKEDIN' },
    { icon:'🚁', title: t('wiki.usecases.advanced.title'),   desc: t('wiki.usecases.advanced.desc'),   link:'https://www.linkedin.com/posts/flyingbasket_flyingbasket-dronelogistics-activity-7397619445734502400-3dAB', tag:'LINKEDIN' },
  ];

  const certifications = [
    { role: t('wiki.guide.certs.manager.role'), color:'#7c3aed', bg:'#ede9fe',
      desc: t('wiki.guide.certs.manager.desc'),
      certs:[{ name: t('wiki.guide.certs.manager.c1.name'), duration: t('wiki.guide.certs.manager.c1.duration') }]
    },
    { role: t('wiki.guide.certs.pilot.role'), color:'#28419a', bg:'#dbeafe',
      desc: t('wiki.guide.certs.pilot.desc'),
      certs:[
        { name: t('wiki.guide.certs.pilot.c1.name'), duration: t('wiki.guide.certs.pilot.c1.duration') },
        { name: t('wiki.guide.certs.pilot.c2.name'), duration: t('wiki.guide.certs.pilot.c2.duration') },
        { name: t('wiki.guide.certs.pilot.c3.name'), duration: t('wiki.guide.certs.pilot.c3.duration') },
        { name: t('wiki.guide.certs.pilot.c4.name'), duration: t('wiki.guide.certs.pilot.c4.duration') },
        { name: t('wiki.guide.certs.pilot.c5.name'), duration: t('wiki.guide.certs.pilot.c5.duration') },
      ]
    },
    { role: t('wiki.guide.certs.assistant.role'), color:'#059669', bg:'#d1fae5',
      desc: t('wiki.guide.certs.assistant.desc'),
      certs:[
        { name: t('wiki.guide.certs.assistant.c1.name'), duration: t('wiki.guide.certs.assistant.c1.duration') },
        { name: t('wiki.guide.certs.assistant.c2.name'), duration: t('wiki.guide.certs.assistant.c2.duration') },
      ]
    },
  ];

  const drones = [
    {
      name: t('wiki.drones.fb3.name'), sub: t('wiki.drones.fb3.sub'),
      tag: t('wiki.drones.fb3.tag'), color:'#28419a', img:'/images/drones/fb3.jpg',
      specs:[
        [t('wiki.drones.specs.payload'),  '100 kg'],
        [t('wiki.drones.specs.autonomy'), '28 min'],
        [t('wiki.drones.specs.speed'),    '22 m/s'],
        [t('wiki.drones.specs.drones'),   '16 m/s'],
        [t('wiki.drones.specs.batteries'),'Waterproof'],
        [t('wiki.drones.specs.power'),    '6.4 kWh'],
      ],
      desc: t('wiki.drones.fb3.desc'),
      usecases: [t('wiki.drones.fb3.uc1'), t('wiki.drones.fb3.uc2'), t('wiki.drones.fb3.uc3'), t('wiki.drones.fb3.uc4')],
    },
    {
      name: t('wiki.drones.fb4.name'), sub: t('wiki.drones.fb4.sub'),
      tag: t('wiki.drones.fb4.tag'), color:'#2d82f8', img:'/images/drones/fb4.jpg',
      specs:[
        [t('wiki.drones.specs.payload'),  '200 kg'],
        [t('wiki.drones.specs.autonomy'), '53 min'],
        [t('wiki.drones.specs.speed'),    '25 m/s'],
        [t('wiki.drones.specs.drones'),   '18'],
        [t('wiki.drones.specs.batteries'),'Waterproof'],
        [t('wiki.drones.specs.power'),    '12.8 kWh'],
      ],
      desc: t('wiki.drones.fb4.desc'),
      usecases: [t('wiki.drones.fb4.uc1'), t('wiki.drones.fb4.uc2'), t('wiki.drones.fb4.uc3'), t('wiki.drones.fb4.uc4')],
    },
  ];

  const roadmap = [
    { step:'01', color:'#28419a', title: t('wiki.guide.roadmap.s1.title'), desc: t('wiki.guide.roadmap.s1.desc') },
    { step:'02', color:'#3a55b8', title: t('wiki.guide.roadmap.s2.title'), desc: t('wiki.guide.roadmap.s2.desc') },
    { step:'03', color:'#7c3aed', title: t('wiki.guide.roadmap.s3.title'), desc: t('wiki.guide.roadmap.s3.desc') },
    { step:'04', color:'#059669', title: t('wiki.guide.roadmap.s4.title'), desc: t('wiki.guide.roadmap.s4.desc') },
    { step:'05', color:'#0891b2', title: t('wiki.guide.roadmap.s5.title'), desc: t('wiki.guide.roadmap.s5.desc') },
  ];

  const easaItems = [
    { icon:'📄', title: t('wiki.norms.easa.i1.title'), desc: t('wiki.norms.easa.i1.desc') },
    { icon:'🗂️', title: t('wiki.norms.easa.i2.title'), desc: t('wiki.norms.easa.i2.desc') },
    { icon:'📓', title: t('wiki.norms.easa.i3.title'), desc: t('wiki.norms.easa.i3.desc') },
    { icon:'🤝', title: t('wiki.norms.easa.i4.title'), desc: t('wiki.norms.easa.i4.desc') },
  ];

  const faaItems = [
    { icon:'📋', title: t('wiki.norms.faa.i1.title'), desc: t('wiki.norms.faa.i1.desc') },
    { icon:'🏛️', title: t('wiki.norms.faa.i2.title'), desc: t('wiki.norms.faa.i2.desc') },
    { icon:'📡', title: t('wiki.norms.faa.i3.title'), desc: t('wiki.norms.faa.i3.desc') },
    { icon:'🤝', title: t('wiki.norms.faa.i4.title'), desc: t('wiki.norms.faa.i4.desc') },
  ];

  return (
    <div className="page-content">
      <h1 style={{ fontFamily:'var(--font-head)', fontSize:'2rem', fontWeight:800, color:'var(--primary)', marginBottom:'0.5rem' }}>{t('wiki.title')}</h1>
      <p style={{ color:'var(--on-surface-muted)', marginBottom:'2rem' }}>{t('wiki.subtitle')}</p>

      <div style={{ display:'flex', gap:'0.75rem', marginBottom:'2.5rem', flexWrap:'wrap' }}>
        {[['drones', t('wiki.tabs.drones')], ['usecases', t('wiki.tabs.usecases')], ['norms', t('wiki.tabs.norms')], ['guide', t('wiki.tabs.guide')]].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} className="btn-secondary"
            style={{ background: tab===k?'var(--primary)':'var(--surface-high)', color: tab===k?'white':'var(--on-surface)', fontWeight:600 }}>
            {l}
          </button>
        ))}
      </div>

      {/* TAB: DRONES */}
      {tab === 'drones' && (
        <div>
          <h2 style={{ fontFamily:'var(--font-head)', fontSize:'1.25rem', fontWeight:700, marginBottom:'0.5rem' }}>{t('wiki.drones.title')}</h2>
          <p style={{ color:'var(--on-surface-muted)', fontSize:'0.875rem', marginBottom:'1.5rem' }}>{t('wiki.drones.subtitle')}</p>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1.5rem' }}>
            {drones.map(d => (
              <div key={d.name} className="card" style={{ padding:0, overflow:'hidden' }}>
                <div style={{ backgroundImage:`url(${d.img})`, backgroundSize:'cover', backgroundPosition:'center', backgroundBlendMode:'multiply', backgroundColor: d.color, borderRadius:'var(--radius-lg) var(--radius-lg) 0 0', height:200, display:'flex', alignItems:'flex-end', padding:'1.25rem', position:'relative' }}>
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.2) 60%, transparent 100%)', borderRadius:'var(--radius-lg) var(--radius-lg) 0 0' }} />
                  <div style={{ position:'absolute', top:12, left:12, background:'rgba(255,255,255,0.18)', backdropFilter:'blur(4px)', borderRadius:6, padding:'0.25rem 0.625rem', fontSize:'0.7rem', fontWeight:700, color:'white' }}>{d.tag}</div>
                  <div style={{ position:'relative', zIndex:1 }}>
                    <div style={{ fontFamily:'var(--font-head)', fontSize:'1.5rem', fontWeight:800, color:'white' }}>{d.name}</div>
                    <div style={{ fontSize:'0.8rem', color:'rgba(255,255,255,0.8)' }}>{d.sub}</div>
                  </div>
                </div>
                <div style={{ padding:'1.25rem' }}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'0.75rem', marginBottom:'1.25rem' }}>
                    {d.specs.map(([l,v]) => (
                      <div key={l} style={{ background:'var(--surface-low)', borderRadius:'var(--radius)', padding:'0.625rem 0.75rem' }}>
                        <div style={{ fontSize:'0.6rem', color:'var(--on-surface-muted)', textTransform:'uppercase', letterSpacing:'0.05em' }}>{l}</div>
                        <div style={{ fontFamily:'var(--font-head)', fontWeight:800, fontSize:'0.95rem', color: d.color, marginTop:'0.2rem' }}>{v}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'0.375rem', marginBottom:'1rem' }}>
                    {d.usecases.map(u => (
                      <span key={u} style={{ fontSize:'0.72rem', fontWeight:600, padding:'0.25rem 0.625rem', borderRadius:999, background:`${d.color}15`, color: d.color }}>{u}</span>
                    ))}
                  </div>
                  <p style={{ fontSize:'0.8rem', color:'var(--on-surface-muted)', lineHeight:1.7, margin:0 }}>
                    <strong style={{ color:'var(--on-surface)' }}>{t('wiki.drones.whyChoose')} </strong>{d.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* TAB: USE CASES */}
      {tab === 'usecases' && (
        <div>
          <h2 style={{ fontFamily:'var(--font-head)', fontSize:'1.5rem', fontWeight:800, marginBottom:'0.5rem' }}>{t('wiki.usecases.title')}</h2>
          <p style={{ color:'var(--on-surface-muted)', fontSize:'0.9rem', marginBottom:'2rem' }}>{t('wiki.usecases.subtitle')}</p>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1.25rem' }}>
            {useCases.map((u,i) => (
              <a key={i} href={u.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration:'none' }}>
                <div className="card" style={{ cursor:'pointer', transition:'box-shadow 0.2s' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'0.75rem' }}>
                    <div style={{ fontSize:'1.75rem' }}>{u.icon}</div>
                    <span style={{ fontSize:'0.65rem', fontWeight:700, padding:'0.2rem 0.6rem', borderRadius:999, background: u.tag==='VIDEO'?'#fee2e2':'#dbeafe', color: u.tag==='VIDEO'?'#dc2626':'#1d4ed8' }}>
                      {u.tag==='VIDEO'?'▶ YouTube':'💼 LinkedIn'}
                    </span>
                  </div>
                  <div style={{ fontFamily:'var(--font-head)', fontWeight:700, fontSize:'0.95rem', color:'var(--primary)', marginBottom:'0.5rem' }}>{u.title}</div>
                  <p style={{ fontSize:'0.8rem', color:'var(--on-surface-muted)', lineHeight:1.6, margin:0 }}>{u.desc}</p>
                </div>
              </a>
            ))}
          </div>
          <div style={{ marginTop:'1.5rem', padding:'1.25rem', background:'var(--surface-low)', borderRadius:'var(--radius-lg)', textAlign:'center' }}>
            <p style={{ color:'var(--on-surface-muted)', fontSize:'0.875rem', margin:0 }}>
              🌍 <strong style={{ color:'var(--primary)' }}>{t('wiki.usecases.cta.bold')}</strong> {t('wiki.usecases.cta.text')}{' '}
              <a href="mailto:info@flyingbasket.com" style={{ color:'var(--teal)', fontWeight:600 }}>info@flyingbasket.com</a>
            </p>
          </div>
        </div>
      )}

      {/* TAB: NORMS */}
      {tab === 'norms' && (
        <div>
          <h2 style={{ fontFamily:'var(--font-head)', fontSize:'1.5rem', fontWeight:800, marginBottom:'0.5rem' }}>{t('wiki.norms.title')}</h2>
          <p style={{ color:'var(--on-surface-muted)', marginBottom:'2rem', fontSize:'0.9rem' }}>{t('wiki.norms.subtitle')}</p>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginBottom:'2rem' }}>
            {[
              { term:'VLOS', full: t('wiki.norms.vlos.full'), color:'#059669', bg:'#d1fae5', icon:'👁', desc: t('wiki.norms.vlos.desc') },
              { term:'BVLOS', full: t('wiki.norms.bvlos.full'), color:'#7c3aed', bg:'#ede9fe', icon:'📡', desc: t('wiki.norms.bvlos.desc') },
            ].map(g => (
              <div key={g.term} style={{ background:g.bg, borderRadius:'var(--radius-lg)', padding:'1.25rem' }}>
                <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'0.75rem' }}>
                  <span style={{ fontSize:'1.5rem' }}>{g.icon}</span>
                  <div>
                    <div style={{ fontFamily:'var(--font-head)', fontWeight:800, fontSize:'1.25rem', color:g.color }}>{g.term}</div>
                    <div style={{ fontSize:'0.75rem', color:g.color, fontWeight:600 }}>{g.full}</div>
                  </div>
                </div>
                <p style={{ fontSize:'0.83rem', color:'var(--on-surface)', lineHeight:1.7, margin:0 }}>{g.desc}</p>
              </div>
            ))}
          </div>

          <div className="card" style={{ marginBottom:'1.5rem', borderLeft:'4px solid #3a55b8' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'1rem' }}>
              <span style={{ fontSize:'1.5rem' }}>🇪🇺</span>
              <div>
                <h3 style={{ fontFamily:'var(--font-head)', fontWeight:800, color:'var(--primary)', margin:0 }}>{t('wiki.norms.easa.title')}</h3>
                <div style={{ fontSize:'0.75rem', color:'var(--on-surface-muted)' }}>{t('wiki.norms.easa.sub')}</div>
              </div>
            </div>
            <div style={{ background:'#eff6ff', borderRadius:'var(--radius)', padding:'1rem', marginBottom:'1rem', fontSize:'0.85rem', color:'#1e40af', lineHeight:1.7 }}>
              💡 <strong>{t('wiki.norms.easa.tipBold')}</strong> {t('wiki.norms.easa.tip')}
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
              {easaItems.map(item => (
                <div key={item.title} style={{ background:'var(--surface-low)', borderRadius:'var(--radius)', padding:'1rem' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', marginBottom:'0.5rem' }}>
                    <span>{item.icon}</span>
                    <span style={{ fontWeight:700, fontSize:'0.875rem', color:'var(--primary)' }}>{item.title}</span>
                  </div>
                  <p style={{ fontSize:'0.8rem', color:'var(--on-surface-muted)', lineHeight:1.6, margin:0 }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="card" style={{ borderLeft:'4px solid #dc2626' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'1rem' }}>
              <span style={{ fontSize:'1.5rem' }}>🇺🇸</span>
              <div>
                <h3 style={{ fontFamily:'var(--font-head)', fontWeight:800, color:'var(--primary)', margin:0 }}>{t('wiki.norms.faa.title')}</h3>
                <div style={{ fontSize:'0.75rem', color:'var(--on-surface-muted)' }}>{t('wiki.norms.faa.sub')}</div>
              </div>
            </div>
            <div style={{ background:'#f0fdf4', borderRadius:'var(--radius)', padding:'1rem', marginBottom:'1rem', fontSize:'0.85rem', color:'#166534', lineHeight:1.7, display:'flex', alignItems:'flex-start', gap:'0.75rem' }}>
              <span style={{ fontSize:'1.25rem', flexShrink:0 }}>✅</span>
              <div dangerouslySetInnerHTML={{ __html: t('wiki.norms.faa.badge') }} />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
              {faaItems.map(item => (
                <div key={item.title} style={{ background:'var(--surface-low)', borderRadius:'var(--radius)', padding:'1rem' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', marginBottom:'0.5rem' }}>
                    <span>{item.icon}</span>
                    <span style={{ fontWeight:700, fontSize:'0.875rem', color:'var(--primary)' }}>{item.title}</span>
                  </div>
                  <p style={{ fontSize:'0.8rem', color:'var(--on-surface-muted)', lineHeight:1.6, margin:0 }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* TAB: GUIDE */}
      {tab === 'guide' && (
        <div>
          <h2 style={{ fontFamily:'var(--font-head)', fontSize:'1.5rem', fontWeight:800, marginBottom:'0.5rem', textAlign:'center' }}>{t('wiki.guide.title')}</h2>
          <p style={{ color:'var(--on-surface-muted)', textAlign:'center', marginBottom:'2.5rem', fontSize:'0.9rem' }}>{t('wiki.guide.subtitle')}</p>

          <div style={{ display:'flex', flexDirection:'column', gap:'1rem', marginBottom:'2.5rem' }}>
            {roadmap.map((s,i) => (
              <div key={i} className="card" style={{ display:'flex', gap:'1.25rem', alignItems:'flex-start' }}>
                <div style={{ width:44, height:44, borderRadius:'50%', background:s.color, color:'white', fontFamily:'var(--font-head)', fontWeight:800, fontSize:'1rem', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{s.step}</div>
                <div>
                  <div style={{ fontFamily:'var(--font-head)', fontWeight:700, fontSize:'1rem', color:'var(--primary)', marginBottom:'0.375rem' }}>{s.title}</div>
                  <p style={{ fontSize:'0.85rem', color:'var(--on-surface-muted)', lineHeight:1.7, margin:0 }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <h3 style={{ fontFamily:'var(--font-head)', fontWeight:800, fontSize:'1.1rem', color:'var(--primary)', marginBottom:'1rem' }}>{t('wiki.guide.certsTitle')}</h3>
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem', marginBottom:'2.5rem' }}>
            {certifications.map((cert,i) => (
              <div key={i} className="card" style={{ borderLeft:`4px solid ${cert.color}` }}>
                <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'0.75rem' }}>
                  <span style={{ fontFamily:'var(--font-head)', fontWeight:800, fontSize:'1rem', color:cert.color }}>{cert.role}</span>
                </div>
                <p style={{ fontSize:'0.82rem', color:'var(--on-surface-muted)', marginBottom:'0.75rem' }}>{cert.desc}</p>
                <div style={{ display:'flex', flexWrap:'wrap', gap:'0.5rem' }}>
                  {cert.certs.map((c,j) => (
                    <div key={j} style={{ background:cert.bg, borderRadius:'var(--radius)', padding:'0.5rem 0.75rem', fontSize:'0.78rem' }}>
                      <span style={{ fontWeight:700, color:cert.color }}>{c.name}</span>
                      <span style={{ color:'var(--on-surface-muted)', marginLeft:'0.5rem' }}>— {c.duration}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <h3 style={{ fontFamily:'var(--font-head)', fontWeight:800, fontSize:'1.1rem', color:'var(--primary)', marginBottom:'1rem' }}>{t('wiki.guide.faqTitle')}</h3>
          <div style={{ display:'flex', flexDirection:'column', gap:'0.75rem' }}>
            {faqs.map((faq,i) => (
              <div key={i} className="card" style={{ cursor:'pointer', padding:'1rem 1.25rem' }} onClick={() => setOpenFaq(openFaq===i?null:i)}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <h4 style={{ fontFamily:'var(--font-head)', fontWeight:700, color:'var(--primary)', fontSize:'0.9rem', margin:0 }}>{faq.q}</h4>
                  <span style={{ fontSize:'1.25rem', color:'var(--on-surface-muted)', marginLeft:'1rem', flexShrink:0 }}>{openFaq===i?'−':'+'}</span>
                </div>
                {openFaq===i && (
                  <p style={{ fontSize:'0.85rem', color:'var(--on-surface-muted)', lineHeight:1.7, marginTop:'0.75rem', marginBottom:0 }}>{faq.a}</p>
                )}
              </div>
            ))}
          </div>

          <div style={{ marginTop:'2rem', background:'linear-gradient(135deg,#003a43,#00535e)', borderRadius:'var(--radius-lg)', padding:'2rem', textAlign:'center', color:'white' }}>
            <div style={{ fontFamily:'var(--font-head)', fontSize:'1.25rem', fontWeight:800, marginBottom:'0.5rem' }}>{t('wiki.guide.cta.title')}</div>
            <p style={{ opacity:0.85, fontSize:'0.875rem', marginBottom:'1.25rem' }}>{t('wiki.guide.cta.desc')}</p>
            <a href="mailto:info@flyingbasket.com" style={{ display:'inline-block', background:'white', color:'#003a43', fontWeight:700, fontSize:'0.875rem', padding:'0.75rem 1.75rem', borderRadius:'var(--radius)', textDecoration:'none' }}>
              ✉️ {t('wiki.guide.cta.btn')}
            </a>
          </div>
        </div>
      )}

      <div style={{ textAlign:'center', padding:'3rem 0 1rem', fontSize:'0.75rem', color:'var(--on-surface-muted)', borderTop:'1px solid var(--surface-high)', marginTop:'3rem' }}>
        © 2024 FLYINGBASKET TECHNOLOGIES. PRECISION IN FLIGHT. &nbsp;|&nbsp;
        <span style={{ cursor:'pointer' }}><a href="https://flyingbasket.com/privacy-policy" target="_blank" rel="noopener noreferrer">{t('common.privacyPolicy')}</a></span> &nbsp;|&nbsp;
        <a href="https://www.flyingbasket.com" target="_blank" rel="noopener noreferrer" style={{ color:'var(--teal)', textDecoration:'none' }}>www.flyingbasket.com</a>
      </div>
    </div>
  );
}
